import { GUTTER_PX } from "../constants";
import { clamp } from "./clamp";

interface ClampPositionWithGutterInput {
  x: number;
  y: number;
  widthPct: number;
  heightPct: number;
  rectWidth: number;
  rectHeight: number;
}

/**
 * Клампит позицию top-left overlay'а так, чтобы он целиком оставался внутри
 * box'а (canvas + gutter):
 *   - левый край overlay'а ≥ -gutter (= box.left)
 *   - правый край overlay'а ≤ 100 + gutter (= box.right)
 * Если overlay шире/выше чем canvas+2*gutter — maxX/Y < minX/Y, поэтому
 * используем Math.max, чтобы не отдавать инвертированный диапазон в clamp.
 */
export const clampPositionWithGutter = ({
  x,
  y,
  widthPct,
  heightPct,
  rectWidth,
  rectHeight,
}: ClampPositionWithGutterInput): { x: number; y: number } => {
  const gutterPctX = (GUTTER_PX / rectWidth) * 100;
  const gutterPctY = (GUTTER_PX / rectHeight) * 100;
  const minX = -gutterPctX;
  const maxX = Math.max(minX, 100 + gutterPctX - widthPct);
  const minY = -gutterPctY;
  const maxY = Math.max(minY, 100 + gutterPctY - heightPct);
  return {
    x: clamp(x, minX, maxX),
    y: clamp(y, minY, maxY),
  };
};
